import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import PartyInfoForTableRow from './PartyInfoForTableRow';
import { userprofileInfo } from 'store/slice/HeaderSlice';


export default function PartyListTableRow({obj, getActionComponent,handleRowClick}){
  const {userprofileInfo} = useSelector((state) => state.headerslice);
  useEffect(()=>{
  },[])
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  backgroundColor: obj.expand?'primary.200':'white',
              '&:hover': {
                backgroundColor: 'secondary.lighter', color: 'primary.main'
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            
              <Grid item lg={6} xs={6} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid>
              <Grid item lg={2} xs={4} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{ obj.statusname==='' || obj.statusname===null?'DRAFT':obj.statusname }</Typography></Grid>

              {/*}
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.contact}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.contactmobile}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.druglicense}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.gst}</Typography></Grid>
             
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.address}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.corporateemail}</Typography></Grid>
              */}

              <Grid item lg={2} xs={2} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {getActionComponent(obj)}
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        {obj.expand && (obj.statusname==='DRAFT' || obj.statusname==='REFERRED BACK' || userprofileInfo.rolename === 'PHARMA_OMS_MD' || userprofileInfo.rolename === 'PHARMA_OMS_MANAGER' || userprofileInfo.rolename === 'PHARMA_OMS_ADMIN')?
        <Grid container direction="row" >
          <Grid item sx={{ width: '100%' }}>
            < PartyInfoForTableRow  partyObj={obj} />
          </Grid>
          <Grid item sx={{ width: '100%', paddingBottom:.15, backgroundColor:'primary.200'}}></Grid>
        </Grid>
        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>}
      </>
      
    )
}